import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function Camp() {
    return (
        <div className={`camp ${css['camp']}`}>
            <main className="main-content">
                <A />
                <IndexDynamic />
            </main>
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
